import React from "react";
// import Image from "react-bootstrap/Image";
import ProgressBar from "react-bootstrap/ProgressBar";

export const SmallRatingReviewReusableComponent = ({
  fiveStar,
  fourStar,
  threeStar,
  twoStar,
  oneStar,
  progressBar,
  totalReviewCount,
}) => {
  return (
    <React.Fragment>
      <div className="small-rating-review-section ratings-bar-progress">
        <div className="col-12 small-rating-review-sectionone">
          {/* <div className="small-rating-review-sectionone-imagebox">
            <Image
              fluid
              src={require("../../../../../assets/images/superadmin/macd.png")}
            />
          </div> */}
          {/* <div className="small-rating-review-sectionone-textbox">
            <h2 className="small-rating-review-sectionone-textbox-one">
              All Reviews
            </h2>
            <h2 className="small-rating-review-sectionone-textbox-two">
              {totalReviewCount} Reviews
            </h2>
          </div> */}
          <div className="f16-500">Ratings</div>
        </div>
        <div className="col-12 small-rating-review-sectiontwo">
          <div className="row small-rating-review-sectiontwo-row">
            <div className="col-4">
              <div className="f11-500">5.0 stars</div>
            </div>
            <div className="col-8 ">
              <ProgressBar now={fiveStar} className={progressBar} style={{height:'5px'}} />
            </div>
          </div>
          <div className="row small-rating-review-sectiontwo-row">
            <div className="col-4">
              <div className="f11-500">4.0 stars</div>
            </div>
            <div className="col-8">
              <ProgressBar now={fourStar} className={progressBar} style={{height:'5px'}}  />
            </div>
          </div>
          <div className="row small-rating-review-sectiontwo-row">
            <div className="col-4">
              <div className="f11-500">3.0 stars</div>
            </div>
            <div className="col-8">
              <ProgressBar now={threeStar} className={progressBar} style={{height:'5px'}}  />
            </div>
          </div>
          <div className="row small-rating-review-sectiontwo-row">
            <div className="col-4">
              <div className="f11-500">2.0 stars</div>
            </div>
            <div className="col-8">
              <ProgressBar now={twoStar} className={progressBar} style={{height:'5px'}}  />
            </div>
          </div>
          <div className="row small-rating-review-sectiontwo-row">
            <div className="col-4">
              <div className="f11-500">1.0 star</div>
            </div>
            <div className="col-8">
              <ProgressBar now={oneStar} className={progressBar} style={{height:'5px'}} />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
